<template>
  <div class="com-box">
    <div class="title">红包挑战赛设置</div>
    <div class="content">
      <van-form 
        ref="formRef"
        input-align="right" 
        validate-first 
        :show-error-message="false"
        validate-trigger="onSubmit"
      >
        <van-collapse v-model="activeNames" :border="false">
          <van-collapse-item title="挑战时间设置">
            <van-field 
              v-model="formData.countMoneyStartTime" 
              readonly
              class="text-input"
              right-icon="arrow" 
              label="挑战开始时间" 
              placeholder="请选择开始时间"
              @click="choiceTiem('countMoneyStartTime')"
              :rules="[{ required: true, message: '请选择开始时间' }]"
            />
            <van-field 
              v-model="formData.countMoneyEndTime" 
              readonly 
              right-icon="arrow" 
              label="挑战结束时间" 
              placeholder="请选择结束时间"
              @click="choiceTiem('countMoneyEndTime')"
            />
            <van-field 
              v-model="formData.exchangeEndDate" 
              readonly 
              right-icon="arrow" 
              label="兑奖截止时间" 
              placeholder="请选择结束时间"
              @click="choiceTiem('exchangeEndDate')"
            />
          </van-collapse-item>
        </van-collapse>
        <van-field
          :disabled="isDit" 
          v-model="formData.time" 
          label="挑战时间" 
          type="digit" 
          placeholder="请输入时间"
          @blur="chackTime"
        >
          <template #right-icon>秒</template>
        </van-field>
        <van-field
          :disabled="isDit"
          readonly 
          right-icon="arrow"  
          v-model="formData.backgroundMusicName" 
          label="背景音乐" 
          placeholder="请选择"
          @click="openMusicPop"
        />
        <van-field label="奖励设置" label-width="5em" input-align="right">
          <template #input>
            <van-checkbox-group
              :disabled="isDit"
              v-model="formData.awardSet" 
              checked-color="#FF6B31" 
              icon-size="16" 
              direction="horizontal"
            >
              <div class="checkbox-item" v-if="userInfo.countAuthority">
                <van-checkbox name="ranking">排名奖励</van-checkbox>
                <van-icon class="icon" name="question" @click="toast('ranking')"/>
              </div>
              <div class="checkbox-item">
                <van-checkbox name="ladder">阶梯奖励</van-checkbox>
                <van-icon class="icon" name="question" @click="toast('ladder')"/>
              </div>
              <div class="checkbox-item">
                <van-checkbox name="random">随机奖励</van-checkbox>
                <van-icon class="icon" name="question" @click="toast('random')"/>
              </div>
              <div class="checkbox-item">
                <van-checkbox name="encourage">鼓励奖励</van-checkbox>
                <van-icon class="icon" name="question" @click="toast('encourage')"/>
              </div>
            </van-checkbox-group>
          </template>
        </van-field>
        <template v-if="formData.awardSet.includes('ranking')">
          <van-field label="排名统计纬度">
            <template #input>
              <van-checkbox-group
                :disabled="isDit" 
                v-model="formData.rankingType" 
                checked-color="#FF6B31" 
                icon-size="16" 
                direction="horizontal"
              >
                <van-checkbox name="global">全国</van-checkbox>
                <van-checkbox name="office">办事处</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <template v-if="formData.rankingType.includes('global')">
            <div class="title" >全国名次奖励设置</div>
            <count-money-list
              awardSetType="global"
              v-if="formData.globalprize.length"
              :list="formData.globalprize"
              :isEdit="isDit"  
              @edit="edit" 
              @del="del"
            />
            <div class="btn-box" v-if="!isDit" @click="addPrize('global')">添加全国名次奖励</div>
          </template>
          <template v-if="formData.rankingType.includes('office')">
            <div class="title" >办事处名次奖励设置</div>
             <count-money-list
              awardSetType="office"
              v-if="formData.officePrize.length"
              :list="formData.officePrize" 
              :isEdit="isDit" 
              @edit="edit" 
              @del="del"
            />
            <div class="btn-box" v-if="!isDit" @click="addPrize('office')">添加办事处名次奖励</div>
          </template>
        </template>
        <template v-if="formData.awardSet.includes('ladder')">
          <div class="title" >阶梯奖励设置</div>
           <count-money-list
              awardSetType="ladder"
              v-if="formData.ladderPrize.length"
              :list="formData.ladderPrize"
              :isEdit="isDit" 
              @edit="edit" 
              @del="del"
            />
            <div class="btn-box" v-if="!isDit" @click="addPrize('ladder')">添加阶梯奖励</div>
        </template>
        <template v-if="formData.awardSet.includes('random')">
          <div class="title" >随机奖励设置</div>
          <count-money-list
            awardSetType="random"
            v-if="formData.randomPrize.length"
            :list="formData.randomPrize"
            :isEdit="isDit"
            @edit="edit" 
            @del="del"
          />
          <div class="btn-box" v-if="!isDit" @click="addPrize('random')">添加随机奖励</div>
        </template>
        <template v-if="formData.awardSet.includes('encourage')">
          <div class="title">鼓励奖励设置</div>
          <count-money-list
            awardSetType="encourage"
            v-if="formData.encouragePrize.length"
            :list="formData.encouragePrize" 
            :isEdit="isDit" 
            @edit="edit" 
            @del="del"
          />
          <div class="btn-box" v-if="!formData.encouragePrize.length && !isDit" @click="addPrize('encourage')">添加鼓励奖励</div>
        </template>
       
        <van-collapse v-model="activeNames" :border="false">
          <van-collapse-item
            name="taskConf1"
            class="collapse-item"
          >
           <template #title>
            <div class="title">挑战机会设置</div>
          </template>
            <!-- <van-field
              :disabled="isDit"
              v-model="formData.everyOneMaxWinCount"
              type="digit"
              :maxlength="4"
              label="每人最多可中奖次数"
              label-width="18em"
              input-align="right"
              placeholder="请输入"
              @blur="checkFeeValid('everyOneMaxWinCount')"
            /> -->
            <van-field
              v-model="everyDaySendName"
              label="赠送挑战机会"
              input-align="right"
              placeholder="请选择"
              is-link
              readonly
              @click="givetypeChange"
            >
            </van-field>
            <van-field
              v-model="formData.everyDaySendCount"
              type="digit"
              :maxlength="4"
              :label="label"
              input-align="right"
              placeholder="请输入"
              @blur="checkFeeValid('everyDaySendCount')"
            >
              <span slot="right-icon">次抽奖机会</span>
            </van-field>

            <div class="field-item border-bottom">
              <div class="field-item-title bold">
                顾客拉新
                <van-radio-group 
                  v-model="formData.boolNewPeopleSendCount" 
                  direction="horizontal" 
                  icon-size="16px" 
                  checked-color="#FF6B31"
                >
                  <van-radio :name="false">关闭</van-radio>
                  <van-radio :name="true">开启</van-radio>
                </van-radio-group>
              </div>
              <span class="tips switch-tips">完成顾客拉新任务获得额外挑战机会</span>
            </div>
            <template v-if="formData.boolNewPeopleSendCount">
              <div class="other">
                <van-field
                  v-model="formData.everyTimeNewPeopleNumber"
                  type="digit"
                  :maxlength="4"
                  label="邀请新客查看活动,每拉新"
                  label-width="12em"
                  input-align="center"
                  placeholder="请输入"
                  @blur="checkFeeValid('everyTimeNewPeopleNumber')"
                >
                  <span slot="right-icon">人可获得</span>
                </van-field>
              </div>
              <div class="list">
                <div class="list-other">
                  <van-field
                    v-model="formData.newPeopleSendCount"
                    type="digit"
                    :maxlength="4"
                    input-align="center"
                    placeholder="请输入"
                    class="other"
                    @blur="checkFeeValid('newPeopleSendCount')"
                  >
                    <span slot="right-icon">次机会,最多送</span>
                  </van-field>
                </div>
                <div class="list-other-1">
                  <van-field
                    v-model="formData.newPeopleSendTotalCount"
                    type="digit"
                    :maxlength="4"
                    input-align="center"
                    placeholder="请输入"
                    @blur="checkFeeValid('newPeopleSendTotalCount')"
                  >
                    <span slot="right-icon">次挑战机会</span>
                  </van-field>
                </div>
              </div>
              <span class="tips">
                <van-icon name="warning-o" />
                第三个空必须是第二个空的倍数
              </span>
            </template>
            <template>
              <div class="field-item border-bottom">
                <div class="field-item-title bold">
                  报名
                  <van-radio-group
                    v-model="formData.boolSignUpSendCount" 
                    direction="horizontal" 
                    icon-size="16px" 
                    checked-color="#FF6B31"
                  >
                    <van-radio :name="false">关闭</van-radio>
                    <van-radio :name="true">开启</van-radio>
                  </van-radio-group>
                </div>
                <span class="tips switch-tips">完成报名任务获得额外挑战机会</span>
              </div>
             
              <van-field
                v-if="formData.boolSignUpSendCount"
                v-model="formData.signUpSendCount"
                type="digit"
                :maxlength="4"
                label="顾客成功报名活动,可获得"
                label-width="12em"
                input-align="center"
                placeholder="请输入"
                @blur="checkFeeValid('signUpSendCount')"
              >
                <span slot="right-icon">次挑战机会</span>
              </van-field>
            </template>
            <div class="field-item">
              <div class="field-item-title bold">
                屏蔽内部职员
                <van-radio-group 
                  v-model="formData.boolInternalStaffLimit" 
                  direction="horizontal" 
                  icon-size="16px" 
                  checked-color="#FF6B31"
                >
                  <van-radio :name="false">关闭</van-radio>
                  <van-radio :name="true">开启</van-radio>
                </van-radio-group>
              </div>
              <span class="tips switch-tips">开启后内部职员将无法中奖</span>
            </div>
          </van-collapse-item>
        </van-collapse>
        <div class="title">红包挑战赛规则</div>
        <div class="rule-item" v-for="(item,index) in formData.rule" :key="index">
          <van-field class="field-border" label="" :maxlength="200" v-model="item.text" input-align="left" placeholder="请输入规则"></van-field>
          <span @click="delRule(index)">删除</span>
        </div>
        <div class="btn-box" @click="addRule">添加规则</div>
      </van-form>
    </div>
    <van-popup v-model="isTimePopup" position="bottom" get-container="body">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
    <van-popup v-model="isMusicPop" position="bottom" get-container="body" >
      <van-picker
        value-key="name"
        show-toolbar
        :columns="columns"
        @confirm="changeMusic"
        @cancel="onCancel"
      />
    </van-popup>
    <van-action-sheet
      v-model="iSgivetype"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      get-container="body"
      @cancel="onCancel"
      @select="changeGive"
    />
    <add-money-pop 
      :isShowPrizePop.sync="isShowPrizePop" 
      :awardSetType="awardSetType"
      :prize="prize"
      :isEdit="isDit"
      :rankRange="rankRange"
      :globalCurrentIndex="globalCurrentIndex"
      @prizeSaveSuccess="prizeSaveSuccess"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from "@/utils/dayjs";
import _ from 'loadsh'
import { round2Places } from "@/utils/utils";
import addMoneyPop from './add-money-pop'
import countMoneyList from './count-money-list'
export default {
  components: { addMoneyPop, countMoneyList },
  props: {
    basicInfoForm: {
      type: Object,
      default() {
        return {}
      }
    },
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    isDit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      prize: {},
      activeNames: [],
      isTimePopup: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      timeKey: '',
      iSgivetype: false,
      actions: [
        {name: '每日赠送',type: 'everyDay',},
        {name: '一次性赠送',type: 'once',},
      ],
      isShowPrizePop: false,
      awardSetType: '',
      isEdit: false,
      globalCurrentIndex: 0,
      prizeField: '',
      rankRange: [],
      columns: [],
      isMusicPop: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    source() {
      return this.$route.query.tmpId 
    },
    formData: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('change',newVal)
      }
    },
    everyDaySendName() {
      return this.formData.everyDaySendType == 'everyDay' ? '每日赠送' : '一次性赠送'
    },
    label() {
      return this.formData.everyDaySendType == 'everyDay' ? '每人每日赠送' : '本场活动赠送'
    },
    creationMode() {
      return this.$route.query.creationMode == 'new' ? true : false
    }
  },
  watch: {
    basicInfoForm: {
      handler(newVal) {
        this.initTimeSet(newVal)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.getMusicList()
  },
  methods: {
    initTimeSet() {
      let { startTime,endTime } = {...this.basicInfoForm}
      if (!startTime && this.source && !this.creationMode) return
      this.formData.countMoneyStartTime = startTime.split(" ").length > 1 ? startTime : startTime + " 00:00:00";
      endTime = endTime.split(" ").length > 1 ? endTime : endTime + " 23:59:59";
      this.formData.countMoneyEndTime = endTime;
      let date = endTime.replace(/-/g, "/");
      this.formData.exchangeEndDate =  dayjs(new Date(date).getTime() + 86400000).format('YYYY-MM-DD HH:mm:ss');
    },
    choiceTiem(key) {
      this.timeKey = key
      this.isTimePopup = true
    },
    givetypeChange() {
      this.iSgivetype = true
    },
    confirm(time) {
      this.formData[this.timeKey] = dayjs(time).format("YYYY-MM-DD HH:mm:ss");
      this.isTimePopup = false
    },
    cancel() {
      this.isTimePopup = false
    },
    onCancel() {
      this.iSgivetype = false
      this.isMusicPop = false 
    },
    changeGive(e) {
      this.formData.everyDaySendType = e.type
    },
    openMusicPop() {
      if (!this.isDit) {
        this.isMusicPop = true
      }
    },
    changeMusic(e) {
      const { url, name} = e
      this.formData.backgroundMusic = url
      this.formData.backgroundMusicName = name
      this.isMusicPop = false
    },
    addPrize(type) {
      const prizeField = this.getPrizeSetField(type)
      this.getPrizeRankingRange(prizeField)
      this.globalCurrentIndex = this.formData[prizeField].length
      this.prize = {
        rankingStart: '',
        rankingEnd: '',
        countTime: '', // 挑战次数
        prizeType: 'award',
        prizeName: '',
        prizeCount: '',
        // couponName: '',
        // couponCount: '',
        couponContent: '',
        couponIndate: '', // 优惠券有效期
        probability: '', // 中奖概率
        prizeImg: ''
      }
      this.awardSetType = type
      this.isShowPrizePop = true
    },
    
    prizeSaveSuccess(prize,awardSetType) {
      const prizeField = this.getPrizeSetField(awardSetType)
      if (this.isEdit) {
        this.$set(this.formData[prizeField], this.globalCurrentIndex, prize)
        this.isEdit = false
      }else {
        this.formData[prizeField].push(prize)
      }
    },
    edit(index,awardSetType) {
      this.awardSetType = awardSetType
      const prizeField = this.getPrizeSetField(awardSetType)
      this.getPrizeRankingRange(prizeField)
      const prize = this.formData[prizeField][index]
      this.prize = _.cloneDeep(prize)
      this.isShowPrizePop = true
      this.isEdit = true
      this.globalCurrentIndex = index
    },
    del(index,awardSetType) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否确定要删除？',
      })
        .then(() => {
          const prizeField = this.getPrizeSetField(awardSetType)
          this.formData[prizeField].splice(index, 1)
          this.$toast('删除成功')
        })
    },
    addRule() {
      this.formData.rule.push({text: ''})
    },
    delRule(index) {
      this.formData.rule.splice(index,1)
    },
    chackTime() {
      let time = this.formData.time
      if (time > 999) {
        this.formData.time = 999
      }
      this.formData.time = round2Places(this.formData.time)
    },
    // 参数校验
    verifyParames() {
      return new Promise((resove,reject) => {
        const { 
          countMoneyStartTime, 
          countMoneyEndTime, 
          exchangeEndDate,
          time,
          awardSet,
          rankingType,
          globalprize,
          officePrize,
          ladderPrize,
          randomPrize,
          encouragePrize,
          rule
        } = this.formData
        if (!countMoneyStartTime || !countMoneyEndTime || !exchangeEndDate) {
          this.$toast('请完善挑战时间设置') 
          return
        } 
        let { startTime, endTime } = this.basicInfoForm;
        startTime = (startTime.split(" ").length > 1 ? startTime : startTime + " 00:00:00").replace(/-/g, "/")
        endTime = (endTime.split(" ").length > 1 ? endTime : endTime + " 23:59:59").replace(/-/g, "/")
        let startDate = countMoneyStartTime.replace(/-/g, "/");
        let endDate = countMoneyEndTime.replace(/-/g, "/");
        let exEndDate = exchangeEndDate.replace(/-/g, "/");

        // 挑战时间
        let moneyStartTime = new Date(startDate).getTime();
        let moneyEndTime = new Date(endDate).getTime();
        let exchangeEndTime = new Date(exEndDate).getTime();
        // 活动时间
        let activityStartTime = new Date(startTime + "").getTime();
        let activityEenTime = new Date(endTime).getTime();
        if (moneyStartTime < activityStartTime) {
          this.$toast("挑战开始时间不能小于活动开始时间");
          return;
        } else if (moneyStartTime > activityEenTime) {
          this.$toast("挑战开始时间不能大于活动结束时间");
          return;
        } else if (moneyEndTime < moneyStartTime) {
          this.$toast("挑战结束时间不能小于挑战开始时间");
          return;
        } else if (moneyEndTime > activityEenTime) {
          this.$toast("挑战结束时间不能大于活动结束时间");
          return ;
        } else if (exchangeEndTime < moneyEndTime) {
          this.$toast("兑奖截止时间不能小于挑战结束时间");
          return;
        }
        if (!time) {
          this.$toast("请输入挑战时间");
          return;
        }
        if (awardSet.includes('ranking')) {
          if (!rankingType.length) {
            this.$toast("请选择排名统计维度");
            return;
          }
          if (rankingType.includes('global') && !globalprize.length) {
            this.$toast("请添加全国名次奖励");
            return
          }
          if (rankingType.includes('office') && !officePrize.length) {
            this.$toast("请添加办事处名次奖励");
            return
          }
        }
        if (awardSet.includes('ladder') && !ladderPrize.length) {
          this.$toast("请添加阶梯奖励");
          return
        }
        if (awardSet.includes('random') && !randomPrize.length) {
          this.$toast("请添加随机奖励");
          return
        }
        if (awardSet.includes('encourage') && !encouragePrize.length) {
          this.$toast("请添加鼓励奖励");
          return
        }
        let iScheckout = rule.every(item => item.text)
        if (!iScheckout) {
          this.$toast("请填写规则");
          return
        }

        const {
          boolNewPeopleSendCount,
          boolSignUpSendCount,
          everyTimeNewPeopleNumber,
          newPeopleSendCount,
          newPeopleSendMaxCount,
          signUpSendCount,
        } = this.formData
        if (boolNewPeopleSendCount && (!everyTimeNewPeopleNumber || !newPeopleSendCount)) {
          this.$toast("请完善挑战机会设置");
          return
        } else if (boolNewPeopleSendCount && !newPeopleSendMaxCount) {
          this.$toast({
            message: '《顾客拉新》中第三个空必须是第二个空的倍数',
            duration: 3000
          })
          return
        } else if (boolSignUpSendCount && !signUpSendCount) {
          this.$toast("请完善挑战机会设置");
          return
        }
        resove(true)
      })
    },
    checkFeeValid(fied) {
      let fieldValue = this.formData[fied];
      this.formData[fied] = round2Places(fieldValue);
      const { everyTimeNewPeopleNumber,newPeopleSendCount,newPeopleSendTotalCount} = this.formData
      if (this.formData.boolNewPeopleSendCount) {
        let map = ['everyTimeNewPeopleNumber','newPeopleSendCount','newPeopleSendTotalCount']
        this.formData[fied] = this.formData[fied] == 0 ? 1 : round2Places(fieldValue);
       
        if (map.includes(fied)) {
          this.formData.newPeopleSendMaxCount = ''
          if (!everyTimeNewPeopleNumber || !newPeopleSendCount || !newPeopleSendTotalCount) {
            this.$toast("请完善挑战机会设置");
          }else if (newPeopleSendTotalCount < newPeopleSendCount || (newPeopleSendTotalCount % newPeopleSendCount) !== 0) {
            this.$toast({ message: '《顾客拉新》中第三个空必须是第二个空的倍数',duration: 3000})
          }else {
            this.formData.newPeopleSendMaxCount = newPeopleSendTotalCount / newPeopleSendCount
          }
        }
      }
    },
    // 获取名次设置区间
    getPrizeRankingRange(prizeField) {
      this.rankRange = []
      this.formData[prizeField].forEach(item => {
        this.rankRange.push({
          start: item.rankingStart,
          end: item.rankingEnd
        })
      });
    },
    getPrizeSetField(awardSetType) {
      let mapField = {
        global: 'globalprize', 
        office: 'officePrize',
        ladder: 'ladderPrize',
        random: 'randomPrize',
        encourage: 'encouragePrize'
      }
      return mapField[awardSetType]
    },
    toast(field) {
      let mapTips= {
        ranking: '根据参与活动的用户挑战次数进行排名，排名纬度分为“全国”和“办事处”，设置名次奖励后，活动结束时则自动给用户分发奖励',
        ladder: '用户参与活动时，满足相应阶梯奖励，则可立即获取对应奖励',
        random: '用户参与活动时，根据设置的获奖几率，则可随机立即获取奖励',
        encourage: '用户参与活动过程中，如未获取任何奖励，则可立即获取鼓励奖励'
      }
      this.$toast({
        message: mapTips[field],
        duration: 3000
      });
    },
    getMusicList() {
      this.$api.countMoney.getMusicList()
        .then(res => {
          this.columns = res.data
        })
    }
   
  }
}
</script>

<style lang="stylus" scoped>
  .com-box {
    margin: 15px;
    .title {
      font-size 14px
      font-weight bold
      color #303133
    }
    .content {
      padding 4px;
      padding-bottom: 6px;
      margin-top: 6px;
      border-radius: 8px;
      background: #fff;
      >>> .van-collapse-item__content {
        padding: 0;
        .van-cell__title {
          color #909399
        }
      }
      .checkbox-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        margin-right: 14px;
        >>> .van-checkbox--horizontal {
          margin-right: 0;
          margin-bottom: 0;
        }
        .icon {
          margin-left:4px;
        }
      }
      .checkbox-item:nth-child(2n) {
        margin-right: 0;
      }
      .title {
        margin: 10px 16px;
        font-weight: bold;
      }
      
      .collapse-item {
        .field-item {
          padding 10px 16px
          font-size 14px
          background-color: #fff;
          &-title {
            display: flex
            justify-content: space-between
            align-items: center
            color #323233
            // font-weight 600
          }
        }
        .title {
          margin: 0;
        }
        .tips {
          color: #999;
          font-size: 10px;
          margin-left: 18px;
        }
        .switch-tips {
          margin-left: 0;
          color: red;
        }
        .other {
          >>> .van-cell {
            .van-field__body input {
              border-bottom: 1px solid #909399;
            }
          }
        }
        .list {
          display: flex;
          align-items: center
          >>> .van-cell {
            padding: 2px 16px 10px 16px;
          }
          .list-other {
            >>> .van-cell {
              padding-left: 10px;
              padding-right: 0;
              .van-field__body input {
                border-bottom: 1px solid #909399;
              }
            }
          }
          .list-other-1 {
            >>> .van-cell {
              padding-left: 8px;
              .van-field__body input {
                border-bottom: 1px solid #909399;
              }
            }
          }
        }
      }
      .border-bottom{
        background: #fff;
        border-bottom: 1px solid #f4f4f4;
      }
      .rule-item {
        display: flex;
        padding: 0 16px;
        .field-border {
          flex: 1;
          padding: 4px;
          box-sizing: bold;
          border-bottom: 1px solid #ebedf0;
        }
        .right {
          width: 60px;
        }
      }
      .btn-box {
        margin: 16px;
        padding 8px 0
        text-align: center
        color $mainTextColor
        font-size 14px
        font-weight 600
        border 1px solid $mainTextColor
        border-radius 8px
      }
      
    }
  }
  >>> .van-field__body input {
    color $mainTextColor
  }
</style>